import { validateBirthdayApi } from 'api/registration/validateBirthdateApi'

export const VALIDATE_BIRTHDAY = 'VALIDATE_BIRTHDAY' as const

export const validateBirthdayAction = (birthday: string) => ({
  type: VALIDATE_BIRTHDAY,
  promise: () => validateBirthdayApi(birthday),
})
